import React from "react";

// One sequence-card placeholder that mirrors the real card: name + step lines and a
// status-pill blob, inside the same bordered card. Shared by the pane skeleton and the
// sequences-only loading state.
export const SeqCardSkeleton = () => (
  <div className="inboxV2SeqCard inboxV2SeqCardSkeleton">
    <div className="inboxV2SeqRow">
      <div className="inboxV2SeqInfo">
        <span className="linear-background inboxV2SkLine md" />
        <span className="linear-background inboxV2SkLine sm" />
      </div>
      <span className="linear-background inboxV2SkPill" />
    </div>
  </div>
);

// Skeletons for the three-pane view, using the app-wide `linear-background` shimmer
// (same approach as OutboxCardLoader). Exported per-pane so selecting a contact can
// keep the rail interactive while only the right-hand panes load.

export const ContactRailSkeleton = () => (
  <div className="inboxV2ContactRail">
    {Array.from({ length: 8 }, (_, index) => (
      <div className="inboxV2ContactRow" key={`railLoader${index}`}>
        <span className="linear-background inboxV2SkAvatar" />
        <div className="inboxV2ContactMeta">
          <span className="linear-background inboxV2SkLine lg" />
          <span className="linear-background inboxV2SkLine sm" />
        </div>
        <div className="inboxV2ContactRight">
          <span className="linear-background inboxV2SkSentiment" />
        </div>
      </div>
    ))}
  </div>
);

export const ConvRowSkeleton = () => (
  <div className="inboxV2ConvRow">
    <span className="linear-background inboxV2SkIcon" />
    <div className="inboxV2ConvMeta">
      <span className="linear-background inboxV2SkLine md" />
      <span className="linear-background inboxV2SkLine lg" />
      <span className="linear-background inboxV2SkLine sm" />
    </div>
  </div>
);

export const ConversationsPaneSkeleton = () => (
  <div className="inboxV2ConversationsPane">
    <div className="inboxV2PaneHeader">
      <div className="inboxV2PaneContact">
        <span className="linear-background inboxV2SkAvatar" />
        <div className="inboxV2PaneContactMeta">
          <span className="linear-background inboxV2SkLine lg" />
          <span className="linear-background inboxV2SkLine sm" />
        </div>
      </div>
      <div className="inboxV2PaneTabs">
        {Array.from({ length: 2 }, (_, index) => (
          <span
            className="linear-background inboxV2SkLine md"
            key={`tabLoader${index}`}
          />
        ))}
      </div>
    </div>
    <div className="inboxV2TabBody">
      {Array.from({ length: 6 }, (_, index) => (
        <ConvRowSkeleton key={`convLoader${index}`} />
      ))}
    </div>
  </div>
);

export const ThreadPaneSkeleton = () => (
  <div className="inboxV2ThreadPane">
    <div className="inboxV2ThreadScroll">
      <div className="inboxV2ThreadCard">
        <div className="inboxV2ThreadHead">
          <span className="linear-background inboxV2SkLine md" />
        </div>
        <div className="inboxV2ThreadAddresses">
          <span className="linear-background inboxV2SkLine lg" />
          <span className="linear-background inboxV2SkLine md" />
        </div>
        <div className="inboxV2ThreadMessages">
          {Array.from({ length: 3 }, (_, index) => (
            <div className="inboxV2Message" key={`msgLoader${index}`}>
              <div className="inboxV2MessageHead">
                <span className="linear-background inboxV2SkAvatar" />
                <div className="inboxV2MessageWho">
                  <span className="linear-background inboxV2SkLine md" />
                  <span className="linear-background inboxV2SkLine sm" />
                </div>
              </div>
              <div className="inboxV2MessageContent">
                <span className="linear-background inboxV2SkPara" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const InboxV2Loader = () => (
  <div className="inboxV2 inboxV2Loading">
    <div className="inboxV2Panes">
      <ContactRailSkeleton />
      <ConversationsPaneSkeleton />
      <ThreadPaneSkeleton />
    </div>
  </div>
);

export default InboxV2Loader;
